import * as React from 'react'
import { Button, Descriptions, Modal, Typography } from 'antd'
import { ExclamationCircleOutlined } from '@ant-design/icons'
import { FormattedMessage, useIntl } from 'react-intl'
import { DeleteOutlinedHover } from '../styled'
import { useDeleteDiscount } from '../queries'
import ConfirmDeleteModal from '../../ConfirmDeleteModal'

type Props = {
  id: number
  name: string
}

const DeleteDiscount = ({ id, name }: Props) => {
  const deleteDiscount = useDeleteDiscount()

  return (
    <ConfirmDeleteModal
      item={id}
      loading={deleteDiscount.isLoading}
      deleteItem={deleteDiscount.mutate}
      title={<FormattedMessage id="Discount_Modal_Delete_Confirm_Title" />}
    >
      <Descriptions
        title={<FormattedMessage id="Discount_Modal_Delete_Confirm_Text" />}
      >
        <Descriptions.Item label={<FormattedMessage id="Discount_Name" />}>
          {name}
        </Descriptions.Item>
      </Descriptions>
    </ConfirmDeleteModal>
  )
}

export default DeleteDiscount
